module.exports = __webpack_public_path__ + "static/media/consumer_sales_leads.5d3dac40.jpg";